import React, { useEffect, useRef } from 'react';
import '../styles/style.css';
import '../styles/mediaqueries.css';
import Icon from '@mdi/react';
import { mdiEmail, mdiLinkedin } from '@mdi/js';

const contactItems = [
    {
        icon: mdiEmail,
        label: 'Email',
        value: 'dev@waithakasam.com',
        href: 'mailto:dev@waithakasam.com',
    },
    {
        icon: mdiLinkedin,
        label: 'LinkedIn',
        value: 'linkedin.com/in/idrisfallout',
        href: 'https://www.linkedin.com/in/idrisfallout',
        external: true,
    },
];

function Contacts() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('.fade-up').forEach(el => {
                            el.classList.add('visible');
                        });
                    }
                });
            },
            { threshold: 0.15 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section id="contact" ref={sectionRef}>
            <div className="scan-line" />

            <p className="section__text__p1">Get in Touch</p>
            <h1 className="title">Contact Me</h1>

            {/* Tagline */}
            <p className="fade-up" style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: '0.8rem',
                color: 'var(--dim)',
                textAlign: 'center',
                marginBottom: '0.5rem',
                letterSpacing: '0.05em',
            }}>
                // Open to opportunities, collaborations, and bold ideas.
            </p>

            <div className="contact-info-upper-container fade-up">
                {contactItems.map(({ icon, label, value, href, external }) => (
                    <a
                        key={label}
                        href={href}
                        className="contact-info-container"
                        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    >
                        <Icon
                            path={icon}
                            size={1.2}
                            color="var(--ghost)"
                            aria-hidden="true"
                            style={{ flexShrink: 0 }}
                        />
                        <div>
                            <p style={{
                                fontFamily: "'JetBrains Mono', monospace",
                                fontSize: '0.65rem',
                                color: 'var(--dim)',
                                textTransform: 'uppercase',
                                letterSpacing: '0.1em',
                                marginBottom: '0.2rem',
                            }}>
                                {label}
                            </p>
                            <p style={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontWeight: 600,
                                fontSize: '1rem',
                                color: 'var(--ghost)',
                            }}>
                                {value}
                            </p>
                        </div>
                    </a>
                ))}
            </div>

            {/* Optional message prompt */}
            <div className="fade-up" style={{
                textAlign: 'center',
                marginTop: '2rem',
            }}>
                <button
                    className="btn btn-color-1"
                    onClick={() => window.location.href = 'mailto:dev@waithakasam.com?subject=Hello from your portfolio'}
                >
                    Send a Message →
                </button>
            </div>
        </section>
    );
}

export default Contacts;